
import dayjs from "dayjs";
import { defineComponent } from "vue";
import HelloWorld from "@/components/HelloWorld.vue"; // @ is an alias to /src

export default defineComponent({
  name: "About",
  components: {
    HelloWorld,
  },
  data() {
    return {
      direction: "top",
      pinPadding: 0,
      time: "",
      timer: 0,
      color: "red",
      city: ["", "", ""],
    };
  },
  methods: {
    gotoMain(){
      this.$router.push('/home/newPage')
    }
  },
  created() {
  },

});
